import { createContext } from 'react';

const OptionsContext = createContext({});

export default OptionsContext;
